import { toast } from 'react-toastify';

import api from '../../services/api';
import { sendWebhookTestData } from '../../services/extraServices';
import {
  DEL_WEBHOOK_FAIL,
  DEL_WEBHOOK_REQ,
  DEL_WEBHOOK_SUCCESS,
  GET_WEBHOOK_SETTINGS_FAIL,
  GET_WEBHOOK_SETTINGS_REQ,
  GET_WEBHOOK_SETTINGS_SUCCESS,
  SAVE_WEBHOOK_SETTINGS_FAIL,
  SAVE_WEBHOOK_SETTINGS_REQ,
  SAVE_WEBHOOK_SETTINGS_SUCCESS,
} from '../constants/settings';

export const getWebhookSettings = (curpage) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_WEBHOOK_SETTINGS_REQ });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.get(`/api/webhooks?page=${curpage}`, config);

    dispatch({
      type: GET_WEBHOOK_SETTINGS_SUCCESS,
      payload: data?.body,
    });
  } catch (error) {
    dispatch({
      type: GET_WEBHOOK_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message,
    });

    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;


    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};

export const addWebhookSettings = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SAVE_WEBHOOK_SETTINGS_REQ,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.post(`/api/webhooks`, body, config);

    if (data.success)
      setTimeout(() => {
        toast.success(data?.message || 'Webbhook added Successfully');
      }, 1000);

    dispatch({
      type: SAVE_WEBHOOK_SETTINGS_SUCCESS,
      payload: data?.body,
    });

    setTimeout(() => {
      sendWebhookTestData(data.body?.title, data.body?.url);
    }, 1000);
  } catch (error) {
    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    dispatch({
      type: SAVE_WEBHOOK_SETTINGS_FAIL,
      payload: message,
    });
    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};

export const delWebhookSettings = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DEL_WEBHOOK_REQ,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.delete(`/api/webhooks/${id}`, config);

    if (data.success)
      setTimeout(() => {
        toast.success(data?.body || 'Webbhook deleted Successfully');
      }, 1000);

    dispatch({
      type: DEL_WEBHOOK_SUCCESS,
      payload: id,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    dispatch({
      type: DEL_WEBHOOK_FAIL,
      payload: message,
    });
    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};

export const getAllWebhookSettings = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_WEBHOOK_SETTINGS_REQ });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.get(`/api/webhooks/all`, config);

    const allWebhooks = [{ data: data?.body, metadata: [{}] }];

    dispatch({
      type: GET_WEBHOOK_SETTINGS_SUCCESS,
      payload: allWebhooks,
    });
  } catch (error) {
    dispatch({
      type: GET_WEBHOOK_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message,
    });

    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};
